module.exports = __webpack_public_path__ + "img/2d7e8f8.jpg";